// extracted by mini-css-extract-plugin
module.exports = {"content":"ingredient-details_content__WdJuD","title":"ingredient-details_title__2_5MB","image":"ingredient-details_image__H2-xP","nutrients":"ingredient-details_nutrients__3DmXA"};